var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLiIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 14,
    viewBox: "0 0 8 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M5.05 3.52188L0 7.31188V12.9219C0 13.8819 1.16 14.3619 1.84 13.6819L7.02 8.50188C7.85 7.67188 7.85 6.32188 7.02 5.49188L5.05 3.52188Z",
    fill: "#BBB1CB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 1.08188V7.31188L5.05 3.52188L1.84 0.31188C1.16 -0.35812 0 0.12188 0 1.08188Z",
    fill: "#543D7D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLiIcon);
export default __webpack_public_path__ + "static/media/li-icon.4e7e38fae4e056f25d0f016f257fd1dd.svg";
export { ForwardRef as ReactComponent };